import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, DataTable } from "../components/Table";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data.logs)).catch(() => {}); }, []);

  const columns = [
    { key: "timestamp", header: "Time", render: (r) => <span className="text-xs text-muted-foreground font-mono">{new Date(r.timestamp).toLocaleString()}</span> },
    { key: "user", header: "User", render: (r) => <span className="font-semibold">{r.user}</span> },
    { key: "action", header: "Action", render: (r) => <span className="font-mono text-xs text-primary">{r.action}</span> },
    { key: "reference", header: "Reference", render: (r) => <span className="font-mono text-xs">{r.reference}</span> },
  ];

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="Audit Log" subtitle="Immutable record of sensitive operations" />
      <DataTable testid="audit-table" columns={columns} rows={logs} empty="No audit entries yet" />
    </div>
  );
}
